import { WellnessScoreStatus } from "../../Common/types";

export function getWellbeingStatus(score: number): WellnessScoreStatus {
  if (score === 0) return WellnessScoreStatus.Healthy;
  if (score >= 1 && score <= 2) return WellnessScoreStatus.NeedsAttention;
  return WellnessScoreStatus.NeedsSupport;
}
